import { useEffect } from "react";

const DEFAULTS = {
  title: "Yugiq — AI Technology Company · Web, Apps & AI Automation",
  description:
    "Yugiq is an AI technology company. We design websites, build iOS & Android apps, and deploy AI agents & automation for business.",
};

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Client-side SEO: updates title, meta description, OG/Twitter tags,
 * canonical link and optional JSON-LD. Restores defaults on unmount.
 */
export default function useSeo({ title, description, canonical, keywords, jsonLd } = {}) {
  useEffect(() => {
    const t = title || DEFAULTS.title;
    const d = description || DEFAULTS.description;
    document.title = t;
    setMeta("name", "description", d);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("name", "twitter:title", t);
    setMeta("name", "twitter:description", d);

    let linkEl = document.head.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!linkEl) {
        linkEl = document.createElement("link");
        linkEl.setAttribute("rel", "canonical");
        document.head.appendChild(linkEl);
      }
      linkEl.setAttribute("href", canonical);
    }

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "dynamic");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      document.title = DEFAULTS.title;
      setMeta("name", "description", DEFAULTS.description);
      if (script) script.remove();
    };
  }, [title, description, canonical, keywords, jsonLd]);
}
